import styled from 'styled-components';

const Spacer = styled.div`
  width: ${({ width }) => width};
`;

export default {
  Spacer,
};
